__turbopack_context__.v({
  "panel": "aFCLdW_panel",
});
